import { getApi, getApiWithParam, postApi } from "./api";
//import { getApi, postApi } from "./api";
export const uploadCsv = async (formData) => {
  const response = await postApi("/Inquiry/UploadCsv", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
};
export const GetUploadBatch = async () => {
  return await getApi(`/Inquiry/GetUploadBatch`);
};
export const AssignInquiry = async (formData) => {
  const response = await postApi("/Inquiry/AssignInquiry", formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};
export const GetInquiryDataByStatus = async (
  userId,
  done,
  salesDone,
  orderPunchDone,
  followUpStatusId,
  config = {}
) => {
  const response = await getApiWithParam("/Inquiry/GetInquiryDataByStatus", {
    params: {
      userId,
      done,
      salesDone,
      orderPunchDone,
      followUpStatusId,
    },
    ...config,
  });
  return response;
};

export const GetInquiryDataByPunch = async (
  userId,
    punch = false,
    ringing = false,
    deny = false,
     config = {}
) => {
    const response = await getApiWithParam("/Inquiry/GetInquiryDataByPunch", {
        params: {
          userId,
            punch,
            ringing,
            deny,
        },
         ...config,
    });

    return response;
};

export const AddInquiryRemarks = async (followUpRemarks) => {
  try {
    const response = await postApi(
      "/Inquiry/AddInquiryRemarks", followUpRemarks
    );
    return response;

  } catch (error) {
    console(error);
    throw error.response?.data || error.message;
  }
};

export const UpdateStatus = async (inqId) => {
  try {
    const response = await postApi(`/Inquiry/UpdateStatus?inqId=${inqId}`);
    return response.data;
  } catch (error) {
    console.error("Update Status Error:", error);
    throw error;
  }
};

export const UpdateSalesDone = async (inqId) => {
  try {
    const response = await postApi(`/Inquiry/UpdateSalesDone?inqId=${inqId}`);
    return response.data;
  } catch (error) {
    console.error("Update Status Error:", error);
    throw error;
  }
};

export const UpdatePunchDone = async (inqId) => {
  try {
    const response = await postApi(`/Inquiry/UpdatePunchDone?inqId=${inqId}`);
    return response.data;
  } catch (error) {
    console.error("Update Status Error:", error);
    throw error;
  }
};
